export const BEFORE_LABEL_ID = 'Name_Hoehenzahl';
